import { checkDeviceResolution } from '../utils/check-device-resolution';

const $body = $('body');

// Expand Accordion button
$(document).on('click touchstart', '.js-trigger-accordion', function (event) {
  event.preventDefault();

  const $this = $(this);
  const $target = $($this.attr('href'));
  let barHeight = 0;

  if (!checkDeviceResolution.isMobile) {
    barHeight = $('.js-product-bar').outerHeight();
  }

  // Smooth scroll to target
  $('html, body').animate(
    {
      scrollTop: $target.offset().top - $('.js-header-content').outerHeight() - barHeight,
    },
    400
  );

  $target
    .addClass('is-expanded')
    .find('.js-accordion-body')
    .slideDown(400)
    .closest('.is-expanded')
    .siblings()
    .removeClass('is-expanded')
    .find('.js-accordion-body')
    .slideUp(400);
});

$(document).on('click touchstart', function (event) {
  const $target = $(event.target);

  // Handle Main menu dropdown on touchscreen devices
  if (checkDeviceResolution.isTablet || checkDeviceResolution.isMobile) {
    if (
      !$target.hasClass('js-btn-toggle') &&
      !$target.parent().hasClass('js-btn-toggle') &&
      !$target.hasClass('js-header-nav-wrapper') &&
      !$target.parents('.js-header-nav-wrapper').length
    ) {
      $body.removeClass('show-nav-main');
    }
  }

  // Hide mini cart
  if (
    !$target.hasClass('js-btn-toggle') &&
    !$target.parent().hasClass('js-btn-toggle') &&
    !$target.hasClass('js-mini-cart') &&
    !$target.parents('.js-mini-cart').length
  ) {
    $body.removeClass('show-mini-cart');
  }

  // Hide Popup Search
  if (
    !$target.hasClass('js-btn-toggle') &&
    !$target.parent().hasClass('js-btn-toggle') &&
    !$target.hasClass('popup-search') &&
    !$target.parents('.popup-search').length &&
    !$target.hasClass('snize-ac-results') &&
    !$target.parents('.snize-ac-results').length
  ) {
    $body.removeClass('show-popup-search');
  }

  // Hide Popup Designs
  if (
    !$target.hasClass('js-btn-toggle') &&
    !$target.parent().hasClass('js-btn-toggle') &&
    !$target.hasClass('popup-designs') &&
    !$target.parents('.popup-designs').length
  ) {
    $body.removeClass('show-popup-designs');
  }
});

$(document).on('click', '.js-nav-back', function (event) {
  event.preventDefault();

  $(this).closest('.js-nav-has-dropdown.is-hovered').removeClass('is-hovered');
});

// Handle Main menu dropdown on touchscreen devices
$(document).on('click', '.js-nav a', function (event) {
  if (checkDeviceResolution.isTablet || checkDeviceResolution.isMobile) {
    const $this = $(this);
    const $parent = $this.parent();

    if ($parent.find('> .js-nav-dropdown').length && !$parent.hasClass('is-hovered')) {
      event.preventDefault();

      $parent.toggleClass('is-hovered').siblings().removeClass('is-hovered');
    } else if ($parent.find('> .js-nav-dropdown').length && $parent.hasClass('is-hovered')) {
      if ($this.attr('href') == '#') {
        event.preventDefault();

        $parent.removeClass('is-hovered');
      }
    }
  }
});

// Button Toggle
$(document).on('click', '.js-btn-toggle', function (event) {
  event.preventDefault();

  const $this = $(this);
  const $targetElement = $($this.attr('data-target'));
  const targetElementClass = $this.attr('data-target-class');

  if (!$targetElement.length || ($(this).hasClass('js-btn-mini-cart') && $('body').hasClass('template-cart'))) {
    return;
  }

  $targetElement.toggleClass(targetElementClass);
});

// Fix PLP page Grid buttons "active" class
$(document).on('click', '.bc-sf-filter-display-item', function () {
  $(this).siblings().removeClass('active');
});

$(document).on('click touchstart', '.section-collection .bc-sf-filter-option-block .bc-sf-filter-block-title h3', function () {
  if (!checkDeviceResolution.isMobile) {
    const $this = $(this);

    $this.parents('.bc-sf-filter-option-block').toggleClass('is-active').siblings().removeClass('is-active');
  }
});

$(document).on('keypress', '.section-collection .bc-sf-filter-option-block .bc-sf-filter-block-title h3', function (event) {
  if (!checkDeviceResolution.isMobile) {
    if (event.which == 13) {
      const $this = $(this);

      $this.parents('.bc-sf-filter-option-block').toggleClass('is-active').siblings().removeClass('is-active');
    }
  }
});

// Button Scroll to
$('.js-btn-scroll-to').on('click', function (event) {
  event.preventDefault();

  const $target = $($(this).attr('href'));

  if ($target.length) {
    $('html, body').animate(
      {
        scrollTop: $target.offset().top,
      },
      600
    );

    return false;
  }
});

$(document).on('click touchstart', '.js-btn-search', function () {
  const $this = $(this);

  setTimeout(function () {
    if (checkDeviceResolution.isDesktop) {
      $('.js-popup-search').find('input').focus();
    }
  }, 200);
});
